const atLeastOneNumber = (value) => /[0-9]/.test(value);
const atLeastEightCharacters = (value) => !!( value.length >= 8 );
const atLeastOneMayus = (value) => /[A-Z]/.test(value);
const atLeastOneMinus = (value) => /[a-z]/.test(value);
const atLeastOneMinusAndMayus = (value) => !!(atLeastOneMayus(value) && atLeastOneMinus(value));
const atLeastOneSpecialCharacter = (value) => /[.,;/()!@#%&·$+<>=^{}_?¿:-]/.test(value);
const isCorrectEmailFormat = (value) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
const maxDigitsAndDecimals = (value) => /^-?((?!0)\d{1,15}|0|\.\d{1,2})($|\.$|\.\d{1,2}$)/.test(value);
const maxDigitsAndDecimals2 = (value) => /^-?(?:(?:[1-9]\d{0,2}(?:,\d{3})+)|(?:[1-9]\d{0,14}|\d))(?:\.\d{1,2})?$/.test(value);
const percentage = (value) => /^(100(\.00?)?|\d{1,2}(\.\d{1,2})?%?)$/.test(value);

const rateNumbers = (value) => /^(?:\d|[1-9]\d|100)(\.\d+)?$/.test(value);
const rateDecimals = (value) => /^(?:\d|[1-9]\d|100)(\.\d{1,2})?$/.test(value);

export {
    atLeastOneNumber,
    atLeastEightCharacters,
    atLeastOneMinusAndMayus,
    atLeastOneSpecialCharacter,
    isCorrectEmailFormat,
    maxDigitsAndDecimals,
    maxDigitsAndDecimals2,
    percentage,
    rateNumbers,
    rateDecimals
}